import { render } from "./SquircleComponent.vue?vue&type=template&id=5ba234b1&scoped=true"
import script from "./SquircleComponent.vue?vue&type=script&lang=js"
export * from "./SquircleComponent.vue?vue&type=script&lang=js"

import "./SquircleComponent.vue?vue&type=style&index=0&id=5ba234b1&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba234b1"]])

export default __exports__